import {PartnershipDto, PartnershipPlayerDto} from "./partnership.dto";
import { SetInfoDto } from "./set.dto";

export type MatchStatus = 'NotStarted' | 'InProgress' | 'Completed' | 'Cancelled';
export type MatchType = 'Practice' | 'Scrimmage' | 'Tournament' | 'Other';

export interface MatchBasicInfoDto {
  id: number;
  tenantId: number;
  season: string;
  homePartnership: PartnershipDto;
  awayPartnership: PartnershipDto;
  type: MatchType;
  status: MatchStatus;
  winningPartnershipId?: number;
  location?: string;
  date: string;
  createdAt: string;
  createdBy: number;
  deletedAt?: string; // Soft-deleted matches are only returned when explicitly requested
}

export interface MatchInfoDto extends MatchBasicInfoDto {
  sets: SetInfoDto[];
}

export interface AddMatchDto {
  season: string;
  homePartnershipId: number;
  awayPartnershipId: number;
  type: MatchType;
  status: MatchStatus;
  location?: string;
  date: string;
}

export interface UpdateMatchDto {
  season?: string;
  homePartnershipId?: number;
  awayPartnershipId?: number;
  winningPartnershipId?: number;
  type?: MatchType;
  status?: MatchStatus;
  location?: string;
  date: string;
}

export const validateAddMatchDto = (dto: Partial<AddMatchDto>): string | null  => {
  const errors: string[] = [];

  // Validate type
  if (['Practice', 'Scrimmage', 'Tournament', 'Other'].indexOf(dto.type as string) < 0) {
    errors.push('type must be one of "Practice", "Scrimmage", "Tournament", or "Other".');
  }

  // Validate status
  if (['InProgress', 'Completed', 'Cancelled'].indexOf(dto.status as string) < 0) {
    errors.push('status must be one of "InProgress", "Completed", or "Cancelled".');
  }

  // Validate date
  if (typeof dto.date !== 'string') {
    errors.push('date must be a string.');
  }

  // Validate optional fields
  if (dto.location && typeof dto.location !== 'string') {
    errors.push('location must be a string if present.');
  }

  return errors.length > 0 ? errors.join(' ') : null;
};